import React from 'react';
import PageableTable from '../pageableTable/PageableTable';
import useTableData from '../pageableTable/useTableData';
import PageableTables from '../pageableTable/PageableTables';
import Payout from '../../../components/siteadmin/ReservationManagement/Payout';
import ModalForm from '../../../components/siteadmin/ReservationManagement/ModalForm/ModalForm';

const actions = [
  {
    Header: 'Payout',
    id: 'payout', // It needs an ID
    Cell: ({ row }) => {
      // Use Cell to render an expander for each row.
      // We can use the getToggleRowExpandedProps prop-getter
      // to build the expander.
      const hTrans = row.original.transaction_histories.filter(
        h => h.user_id === row.original.hostId,
      );
      const hostTransaction = hTrans && hTrans.length > 0 ? hTrans[0] : null;
      return (
        <Payout
          hostId={row.original.hostId}
          checkIn={row.original.checkIn}
          checkOut={row.original.checkOut}
          id={row.original.id}
          hostPayout={
            row.original.hostPayouts && row.original.hostPayouts.length > 0
              ? row.original.hostPayouts.filter(x => x.isDefault)[0]
              : null
          }
          amount={row.original.total}
          currency={'USD'}
          hostTransaction={hostTransaction}
          reservationState={row.original.reservationState}
          cancelData={null}
          hostData={row.original.userByHostId.user_profiles[0]}
          hostServiceFee={row.original.hostServiceFee}
        />
      );
    },
  },
];

function Reservations(props) {
  const res = useTableData(PageableTables.payouts);
  const { data, loading, pageCount, fetchData, columns } = res;
  return (
    <div>
      <ModalForm />
      <PageableTable
        columns={[...columns, ...actions]}
        data={data}
        fetchData={fetchData}
        loading={loading}
        pageCount={pageCount}
        renderRowSubComponent={() => <div>sub</div>}
      />
    </div>
  );
}

export default Reservations;



// WEBPACK FOOTER //
// ./src/routes/siteadmin/reservations/Reservations.js